import * as Immutable from "immutable";
export default class Grantee {
  constructor(id, title, type) {
    this._value = { id, title, type };
  }
  get id() {
    return this._value.id;
  }
  get title() {
    return this._value.title;
  }
  get type() {
    return this._value.type;
  }
  toBuilder() {
    const { id, title, type } = this._value;
    return new Builder(Immutable.Map({ id, title, type }));
  }
  toJSON() {
    const { id, title, type } = this._value;
    return { id, title, type };
  }
  static fromJSON(value) {
    const { id, title, type } = value;
    return Grantee.builder().id(id).title(title).type(type).build();
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  title(value) {
    return new Builder(this.value.set("title", value));
  }
  type(value) {
    return new Builder(this.value.set("type", value));
  }
  build() {
    const { id, title, type } = this.value.toObject();
    return new Grantee(id, title, type);
  }
}
